<template>
  <div>
    <div class="container" v-if="data">
      <div class="row mb-4">
        <!-- <div class="col-md-12">
          <boton-atras :nombre_ruta="'Home'"/>
        </div> -->
          <div class="col-md-6" v-for="(item, i) in data" :key="i" >
            <router-link :to="{name: routeo(item.id)}">
              <cardsMenu  :card="item"/>
            </router-link>
          </div>
        </div>
        <div class="mb-5">
          <span v-html="fecha_actualizacion"></span>
        </div>
    </div>
  </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import RendicionDeCuentas from "@/services/rendicionDeCuentas/rendicionDeCuentas.js";
const _serviciosRendicionC = new RendicionDeCuentas();
import cardsArray from '../../components/cardsArray.vue';
import cardsMenu from '../../components/cardsMenu.vue';
import botonAtras from './../button-atras'
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
  components: { cardsMenu, cardsArray, botonAtras},
  data() {
        return {
            data: [],
            error: '', // Maneja mensajes de error
            loading: true, // Indicador de carga
            fecha_actualizacion:''
        };
    },
    async created() {
        await this.getMenuRendicionCuentas();
    },
    mixins: [DateFormat],
    methods: {
      routeo(n){
          switch(n) {
            case 1: return "Presupuesto-de-Egresos";
            case 2: return "Finanzas-publicas";
            case 3: return "Gestion-financiera" //  /Gestion-financiera;
            case 4: return "Recursos-a-Municipios"
            case 5: return "Estrategico-institucional-org-pub"
            case 6: return "Cuentas-Publicas"; //Cuentas-Publicas
            case 7: return "Trimestral-publicas"; //Trimestral-publicas
            case 8: return "Presup-egres-org-pub";
            case 9: return "SFU";
            case 10: return "SRFT";
            default: break;
          }
        },
        /*routeo(n){
          switch(n) {
            case 1: return "Presupuesto-de-Egresos";
            case 2: return "Finanzas-publicas";
            case 3: return "Gestion-financiera";
            case 4: return "Recursos-a-Municipios";
            case 5: return "Estrategico-institucional-org-pub";
            case 6: return "Cuentas-Publicas";
            case 7: return "Trimestral-publicas";
            case 8: return "Presup-egres-org-pub";
            default: break;
          }
        },*/
        async getMenuRendicionCuentas() {
            try {
                const response = await _serviciosRendicionC.getMenuRendicionCtas(mapFun.rendicionCtasMenu);
                this.data = response.data;
                let fecha_texto = this.data[this.data.length - 1].fecha_actualizacion;
                this.fecha_actualizacion = this.DateFormatText(fecha_texto);
            } catch (error) {
                console.log('error', error.message);
            }
        }
    }
}
</script>
